



import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Row,
  Col,
} from "reactstrap";
import SimpleBar from "simplebar-react";
import FeatherIcon from "feather-icons-react";
import { withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { logoutReset, NotificationEventData } from "../../../store/actions";
import { GET_COMPANY_FROM_URL } from "../../Common/CommonFunction";
import { useSession } from "../../../routes/middleware/SessionContext";

const NotificationDropdown = (props) => {

  const dispatch = useDispatch()
  const { updateSessionActivity } = useSession();
  const [menu, setMenu] = useState(false);
  const [notifications, setNotifications] = useState([]);

  const { Notification_Data } = useSelector(state => ({
    Notification_Data: state.Login.Notification_Data,
  }))


  useEffect(() => {
 
    try {
      if ((Notification_Data.type === "logout") || (Notification_Data.type === "refresh")) {
        
        setNotifications((prev) => {
          const exists = prev.some(
            (item) => item.type === Notification_Data.type
          );

          if (exists) return prev;

          return [
            {
              id: Date.now(),
              type: Notification_Data.type,
              title: "New Update Available",
              message:
                `A new version of the application is available.Please ${Notification_Data.type} to get the latest updates`,
              time: "Just now",
            },
            ...prev,
          ];
        });

      }
    } catch (err) {
      console.error("SSE Parse Error:", err);
    }

  }, [Notification_Data]);

  const handleReload = (show) => {
    
    if (show.type === "logout") {
      dispatch(NotificationEventData({}));

      updateSessionActivity({
        session: false,
      })
      const CompanyCode = GET_COMPANY_FROM_URL();
      for (let key in localStorage) {

        if (
          key.startsWith(`${CompanyCode}_`) &&
          key !== `${CompanyCode}_companyCode` &&
          key !== `${CompanyCode}_companyTheme` &&
          key !== `${CompanyCode}_companyID`
        ) {
          localStorage.removeItem(key);
        }
      }
      localStorage.setItem("Logout", `${CompanyCode}`);
      sessionStorage.clear()
      dispatch(logoutReset())
      window.location.replace("/login");
    } else {
      dispatch(NotificationEventData({}));

      window.location.reload();
    }
  };

  const handleCloseNotification = (id, e) => {
    e.preventDefault();
    e.stopPropagation();

    setNotifications((prev) =>
      prev.filter((item) => item.id !== id)
    );
  };

  return (
    <Dropdown
      isOpen={menu}
      toggle={() => setMenu(!menu)}
      className="dropdown d-inline-block"
      tag="li"
    >
      <DropdownToggle
        className="btn header-item noti-icon position-relative"
        tag="button"
        id="page-header-notifications-dropdown"
      >
        <FeatherIcon
          icon="bell"
          className="icon-lg"
        />

        {notifications.length > 0 && (
          <span className="badge bg-danger rounded-pill">
            {notifications.length}
          </span>
        )}
      </DropdownToggle>

      <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
        <div className="p-3 border-bottom">
          <Row className="align-items-center">
            <Col>
              <h6 className="m-0">
                {props.t("Notifications")}
              </h6>
            </Col>
          </Row>
        </div>

        <SimpleBar style={{ maxHeight: "300px" }}>
          {notifications.length === 0 ? (
            <div className="text-center p-4 text-muted">
              No Notifications
            </div>
          ) : (
            notifications.map((item) => (
              <div
                key={item.id}
                className="notification-item p-3 border-bottom"
              >
                <div className="d-flex">
                  <div className="avatar-sm me-3">
                    <span className="avatar-title bg-success rounded-circle font-size-16" style={{ width: "35px" }}>
                      <i className="bx bx-refresh"></i>
                    </span>
                  </div>

                  <div className="flex-grow-1">
                    <div className="d-flex justify-content-between">
                      <h6 className="mt-0 mb-1">
                        {item.title}
                      </h6>

                      <button
                        className="btn-close"
                        onClick={(e) =>
                          handleCloseNotification(
                            item.id,
                            e
                          )
                        }
                      />
                    </div>

                    <div className="font-size-12 text-muted">
                      <p className="mb-2">
                        {item.message}
                      </p>

                      <p className="mb-2">
                        <i className="mdi mdi-clock-outline"></i>{" "}
                        {item.time}
                      </p>

                      <button
                        className="btn btn-primary btn-sm"
                        onClick={() => { handleReload(item) }}
                      >
                        {(item.type === "logout") ? "logout" : "Refresh"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </SimpleBar>

        {notifications.length > 0 && (
          <div className="p-2 border-top text-center">
            <Link
              to="#"
              className="btn btn-sm btn-link"
              onClick={(e) => {
                e.preventDefault();
                setNotifications([]);
              }}
            >
              Clear All
            </Link>
          </div>
        )}
      </DropdownMenu>
    </Dropdown>
  );
};

NotificationDropdown.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(NotificationDropdown);